module.exports = __webpack_public_path__ + "img/vessel_image.7db44749.svg";